import { useState, useEffect } from 'react'
import { SubMenu, useAuth } from '@artprov/design-system'
import { useNavigate, useLocation } from "react-router-dom";
import { getRolUsuario } from '../../../services/user/user.service';

const opciones = [{
    label: "Mis solicitudes",
    path: "/"
},
{
    label: "Autorizaciones",
    path: "/autorizaciones"
}]

export default function SubMenuPrincipal() {
    const navigate = useNavigate();
    const location = useLocation();
    const [selected, setSelected] = useState("");
    const { authenticated } = useAuth();
    const [rol, setRol] = useState(null);

    useEffect(() => {
        if (authenticated) {
            getRolUsuario()
                .then(data => {
                    setRol(data.rol);
                })
                .catch(() => setRol(null));
        }
    }, [authenticated]);

    const opcionesDelRol = (rol?.includes('AUTORIZANTE')) ? opciones : opciones.slice(0, 1);

    useEffect(() => {
        if (opcionesDelRol.length > 0) {
            const currentItem = opcionesDelRol.slice(1).find(
                (item) => location.pathname.includes(item.path)
            );

            if (currentItem) {
                setSelected(currentItem.label);
            } else {
                setSelected(opcionesDelRol[0].label);
            }
        }
    }, [location.pathname, opcionesDelRol]);

    const handleNavigation = (item) => {
        const selectedItem = opcionesDelRol.find(
            (menuItem) => menuItem.label === item
        );
        if (selectedItem?.path) {
            navigate(selectedItem.path);
        }
    };

    return (
        <SubMenu submenuItems={opcionesDelRol.map((item) => item.label)}
            classNameContainerMenu="[&_.container]:mx-auto [&_.mx-4]:m-0"
            onClick={handleNavigation}
            selected={selected}
        />
    )
}
